import script from "./VerProducto.vue?vue&type=script&setup=true&lang=js"
export * from "./VerProducto.vue?vue&type=script&setup=true&lang=js"

import "./VerProducto.vue?vue&type=style&index=0&id=112688f0&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-112688f0"]])

export default __exports__